/* eslint-disable react/destructuring-assignment */
import React, { useContext, memo, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import './index.scss';
import { Switch, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { Avatar, Logo, RoundedIcon, Notification } from '../index';
import { ModeSwitch } from '../../template';
import Icons from '../../../configs/icon.config';
import { changeLanguage, commonState } from '../../../app/base/commonSlice';
import { authState } from '../../../app/auth/authSlice';
import { TourContext } from '../../layout';
import av from '../../../assets/person-circle.svg';
import bracLogo from '../../../assets/bracLogoFullCut.png';
import { useDashBoardImagesQuery } from '../../../view/dashboard/store/dashboardSlice';

interface NavProps {
  // label?: string;
  classname?: string;
  styles?: React.CSSProperties;
  onSearchButtonClick: () => void;
}

export function Nav({ classname, styles, onSearchButtonClick }: NavProps) {
  const searchTour: any = useContext(TourContext);
  const avatarStyle = {
    ...styles,
  };
  const classes = classNames('nav h-full', classname);
  const { data: logoData } = useDashBoardImagesQuery();

  const { profile } = useSelector(authState);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const { isAdmin } = useSelector(commonState);

  const profilePic = useMemo(() => profile?.image, [profile?.image]);

  const { t } = useTranslation();

  const { language } = useSelector(commonState);
  const dispatch = useDispatch();

  const logo = () => {
    // if (isLoading && error?.status !== 404) {
    //   return <Skeleton.Image className="custom-img-skeleton" active />;
    // }
    if (logoData) {
      return (
        <Logo
          darkLogo={logoData?.secondary_logo?.dark_mode_image}
          lightLogo={logoData?.secondary_logo?.light_mode_image}
          alt={logoData?.secondary_logo?.alt_text}
        />
      );
    }
    return '';
  };

  const handleLanguageChange = useCallback(() => {
    if (language === 'en') {
      dispatch(changeLanguage('bn'));
    } else {
      dispatch(changeLanguage('en'));
    }
  }, [dispatch, language]);

  return (
    <div className={classes} style={avatarStyle}>
      <nav className="h-full flex justify-between">
        <div className="nav-container h-full">
          <span className="nav-brand flex items-center justify-center h-full ">
            {isMobile ? (
              <Link to={isAdmin ? '/admin' : '/'}>
                <img src={bracLogo} alt="bracLogo" />
              </Link>
            ) : (
              logo()
            )}
          </span>
        </div>
        <div className="nav-avatar">
          <div className="flex gap-8 justify-between items-center">
            <div ref={searchTour.searchRef}>
              <RoundedIcon
                iconName={Icons.search}
                title={`${t('search.message')}`}
                classname="search-button text-pink-600 dark:text-[#EB3E8E]"
                width={35}
                height={35}
                onClick={onSearchButtonClick}
              />
            </div>
            {!isMobile && (
              <>
                <div ref={searchTour.notificationsRef}>
                  <Notification />
                </div>
                <div className="profile">
                  {isEmpty(profilePic) ? (
                    <Avatar avatarImage={av} />
                  ) : (
                    <Avatar
                      avatarImage={`data:image/jpeg;base64,${profilePic}`}
                    />
                  )}
                </div>
              </>
            )}

            <div className="switch">
              <div ref={searchTour.darkModeRef}>
                <ModeSwitch />
              </div>
              <Tooltip
                title={
                  language === 'en'
                    ? `${t('banglaLang.tooltip')}`
                    : `${t('englishLang.tooltip')}`
                }
              >
                <Switch
                  className={classNames('mt-2', {
                    'pointer-events-none': profile?.user_settings?.guided_tour,
                  })}
                  ref={searchTour.languageRef}
                  checkedChildren="English"
                  unCheckedChildren="বাংলা"
                  onChange={handleLanguageChange}
                  defaultChecked={language === 'bn'}
                  checked={language === 'bn'}
                />
              </Tooltip>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

Nav.defaultProps = {
  label: 'Click to check',
};

export default memo(Nav);
